import { Type } from "class-transformer";

export class NiaAddress {
  houseNumber?: string;
  streetName?: string;
  postalCode?: string;
  municipality?: string;
}

export default class NiaResponse {
  dateOfBirth?: Date;
  firstName?: string;
  lastName?: string;
  @Type(() => NiaAddress)
  address?: NiaAddress;
}
